import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {Merchant} from "./MerchantStore";

@makeEnum
export class ExternalAppType extends BaseEnum {
    static FULCO;
    static CDS;
    static AMAZON_PAY;
}

@globalStore
export class ExternalAppConfig extends BaseStore("ExternalAppConfig") {
    @field("Merchant") merchant: Merchant;
    @field(ExternalAppType) provider: ExternalAppType;
    @field(Boolean) isActive: boolean;
    @field(Boolean) isPublic: boolean;

    toString(): string {
        return String(this.provider);
    }
}
